import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "fi-container" }
const _hoisted_2 = { class: "fi-box" }
const _hoisted_3 = {
  key: 0,
  class: "error-msg"
}

import {ref, computed, onMounted, onUnmounted, nextTick} from "vue";
import { useRouter } from "vue-router";
import { useFiStore } from "../stores/buildStores";
import { useAuthStore } from "../stores/authStore";
import { logger } from "../utils/logger";
import { Q2Select } from "q2-tecton-framework-wrappers/dist/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FISearch',
  setup(__props) {

const fiSearchSelect = ref<typeof Q2Select | null>(null);

async function focusWhenReady(element: HTMLElement) {
  // eslint-disable-next-line
  if (typeof (element as any).componentOnReady === "function") {
    // eslint-disable-next-line
    await (element as any).componentOnReady();
  }

  // eslint-disable-next-line
  const el = (element as any).$el ?? element;
  if (el?.focus) {
    el.focus();
  }
}

onMounted(async () => {
  await nextTick(); // ensure the DOM ref is resolved

  if (fiSearchSelect.value) {
    await focusWhenReady(fiSearchSelect.value);
  }
});

onUnmounted(() => {
  logger.debug("🧹 getFInumber.vue unmounted");
});

const fiStore = useFiStore();
const authStore = useAuthStore();
const fiNumber = ref("");
const error = ref("");
const router = useRouter();

const allFis = computed(() => authStore.allFis);

function onInput(event: CustomEvent) {
  // Handles typing in the search field - event.detail contains { query: string }
  const query = event.detail?.query ?? "";
  logger.debug("Search query:", query);

  // Only update fiNumber when user is actively typing (query is not empty)
  // This prevents the dropdown selection from being cleared when the component
  // clears the search field after selecting an item
  if (query) {
    fiNumber.value = query;
  }
}

function onChange(event: CustomEvent) {
  // Handles selecting an option from the dropdown - event.detail contains { value: string, selectedOptions: string[] }
  const value = event.detail?.value ?? event.detail;
  logger.debug("Selected value:", value);

  fiNumber.value = value;
}

function submit() {
  let finalFiNumber = fiNumber.value;
  // If fiNumber is empty or not set, reject
  if (!finalFiNumber) {
    error.value = "FI number is required";
    return;
  }

  // If the value isn't from a selected option, validate it's an integer
  const isValidOption = allFis.value.some(fi => fi.fiNumber === finalFiNumber);
  if (!isValidOption) {
    // Check if it's a valid integer
    if (!/^\d+$/.test(finalFiNumber)) {
      error.value = "Please select a valid FI or enter an FI number";
      return;
    }
    logger.debug("📝 Using manually entered FI number:", finalFiNumber);
  } else {
    logger.debug("✅ Using selected FI option:", finalFiNumber);
  }

  fiStore.setFiNumber(finalFiNumber);
  logger.debug("📅 Selected FI Number:", finalFiNumber);
  error.value = "";

  router.push({
    name: "FIAppsDynamic",
    params: {
      fiNumber: fiStore.getFiNumber,
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_q2_option = _resolveComponent("q2-option")!
  const _component_q2_btn = _resolveComponent("q2-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade-up",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Select an FI", -1)),
          _createVNode(_unref(Q2Select), {
            ref_key: "fiSearchSelect",
            ref: fiSearchSelect,
            onInput: onInput,
            onChange: onChange,
            onKeyup: _withKeys(submit, ["enter"]),
            label: "FI Search",
            placeholder: "Search FI Number or Name",
            searchable: "true",
            required: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allFis.value, (fi) => {
                return (_openBlock(), _createBlock(_component_q2_option, {
                  key: fi.fiNumber,
                  value: fi.fiNumber
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(fi.fiNumber) + " - " + _toDisplayString(fi.fiName), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 512),
          _createVNode(_component_q2_btn, {
            intent: "workflow-primary",
            class: "submit-btn",
            onClick: submit
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Submit ", -1)
            ]))]),
            _: 1
          }),
          (error.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})